module.exports = __webpack_public_path__ + "img/vertical_3_5_7042.9dc3eee4.png";